<template>
  <div class="pw_bg">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">

                <div class="pwHeard">
                    <span class="h_back" @click="back"></span>
                    <span class="h_title">我收藏的博物馆</span>
                   <!-- <span class="h_store" @click="store('mum')">保存</span>-->
                </div>
                <div class="mineList" v-show="nodata">
                   <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                     <li   v-for="item in mumList" class="collectItem"><span @click="gotoMum(item.cid)">{{item.orgName}}</span><a href="javascript:void(0);" @click="del('mum',item.cid)">删除</a></li>
                   </ul>
                </div>
                <div class="nodataContent" v-if="!nodata">
                  <img src="static/images/noData.svg" alt="">
                  <p class="nodataTip">这里还什么都没有哦～</p>
                  <a href="javascript:void(0);" @click="getMore('mum')" class="getMore">马上去收藏</a>
                </div>
              <div class="panation">
                <i class="navbar cur"></i>
                <i class="navbar"></i>
              </div>

            </div>
            <div class="swiper-slide">
              <div class="pwHeard">
                <span class="h_back" @click="back"></span>
                <span class="h_title">我收藏的藏品</span>
              <!--  <span class="h_store" @click="store('collect')">保存</span>-->
              </div>
              <div class="mineLists" v-show="nocangp">
                <ul v-infinite-scroll="loadMores" infinite-scroll-disabled="loadings" infinite-scroll-distance="10">
                  <li   v-for="item in collectionList" class="collectItem"><span @click="gotoCollection(item.cid)">{{item.colName}}</span><a href="javascript:void(0);" @click="del('collect',item.cid)">删除</a></li>
                </ul>
              </div>
              <div class="nodataContent" v-if="!nocangp">
                <img src="static/images/noData.svg" alt="">
                <p class="nodataTip">这里还什么都没有哦～</p>
                <a href="javascript:void(0);" @click="getMore('collect')" class="getMore">马上去收藏</a>
              </div>
              <div class="panation">
                <i class="navbar"></i>
                <i class="navbar cur"></i>
              </div>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
  import {api} from '../global/api';
  import Swiper from 'swiper';
  import { Toast } from 'mint-ui';
  import 'swiper/dist/css/swiper.min.css';
  export default {
    name: "pass-word",
    data(){
      return {
        mySwiper:{},
        loadings:true,
        loading:true,
        mumList:[],
        collectionList:[],
        page:1,
        pages:1,
        size:9,
        changdu:-between()*17.5,
        nodata:true,
        nocangp:true
      }
    },
    mounted(){
      let that=this;
       this.mySwiper = new Swiper('.swiper-container', {
        loop:false,
        /*slidesPerView:1.2,*/
        initialSlide :0,
        /*spaceBetween:between()/2,*/
         freeMode:false,
         observer:true,//修改swiper自己或子元素时，自动初始化swiper
         observeParents:true,//修改swiper的父元素时，自动初始化swiper
         on: {
           slideChangeTransitionEnd: function(){
             if(this.activeIndex==1){
               setTimeout(function(){
                 document.getElementsByClassName("swiper-wrapper")[0].style.transform="translate3d("+that.changdu+"px,0px,0px)"}
                 ,100);
             }
           },
         },
      })
      this.getMum(false);
      this.getCollections(false);
    },
    methods:{
      back(){
        this.$router.go(-1);
      },
      gotoMum(id){
        this.$router.push({
          path: '../mumDetail',
          query: { id: id }
        });
      },
      gotoCollection(id){
        this.$router.push({
          path: '../collectionDetail',
          query: { id: id }
        });
      },
      getMore(str){
        switch(str)
               {
                 case "mum":
                   this.$router.push({
                     path: '../museum',
                   });
                   break;
                 case "collect":
                   this.$router.push({
                     path: '../collection',
                   });
                   break;
                 default:

               }
      },
      del(str,id){
        /*switch(str)
        {
          case "mum":

            break;
          case "collect":

            break;
          default:

        }*/
        let that=this;
        let params={"userID":localStorage['userid'],"token":localStorage['token'],"collectID":id};
        this.$http.get(api.delCollect, {params:params}).then(response => {
          if(response.data.success==1){
            let instance = Toast(
              {
                message: '删除成功！',
                position: 'center',
                duration: 2000,
                iconClass: 'icon icon-success'
              }
            );
            setTimeout(() => {
              instance.close();
            }, 2000);
            that.page=1;
            that.pages=1;
            that.loading=true;
            that.loadings=true;
            str=="collect"?that.getCollections(false):that.getMum(false);
          }else{
            let instance = Toast(
              {
                message: '删除失败！',
                position: 'center',
                duration: 2000,
                iconClass: 'icon icon-fail'
              }
            );
            setTimeout(() => {
              instance.close();
            }, 2000);
          }
        }, response => {
          console.log("请求失败了");
        })
      },
      /*store(str){
        switch(str)
        {
          case "mum":

            break;
          case "collect":

            break;
          default:

        }
      },*/
      loadMore() {

        this.page ++;
        this.loading = true;
        this.getMum(true);

        /*setTimeout(() => {
          this.page ++;
          this.getMum(true);
        }, 500);*/
      },
      loadMores() {


        this.pages++;
        this.loadings = true;
        this.getCollections(true);

        /*setTimeout(() => {
          this.pages++;
          this.getCollections(true);
        }, 500);*/
      },
      getCollections(flag){
        let that = this;
        //Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        let params={userID:localStorage['userid'],"token":localStorage['token'],type:"1",currentPage:this.pages,size:this.size,openPage:"1"};
        this.$http.get(api.myCollects, {params:params}).then(response  => {

          if(response.data.success==1){
            //Indicator.close();
            if(flag){
              that.collectionList = that.collectionList.concat(response.data.data);
              if(response.data.data.length == 0){
                this.loadings = true;

              }else{
                this.loadings = false;
              }
            }else{
              if(response.data.data.length>0) {
                this.collectionList = response.data.data;
                this.loadings = false;
                that.nocangp=true;
              }else{
                that.nocangp=false;
                //that.loading = true;
                that.loadings = true;
              }
            }
          }else if(response.data.success==999){
            this.$router.push({ path: './login'});

          }else{
            console.log("接口异常");
          }
        }, response => {
        })
      },
      getMum(flag){
        let that = this;
        //Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        let params={userID:localStorage['userid'],"token":localStorage['token'],type:"2",currentPage:this.page,size:this.size,openPage:"1"};
        this.$http.get(api.myCollects, {params:params}).then(response  => {
          if(response.data.success==1){
            //Indicator.close();
            if(flag){
              that.mumList = that.mumList.concat(response.data.data);
              if(response.data.data.length == 0){
                this.loading = true;
              }else{
                this.loading = false;
              }
            }else{
               if(response.data.data.length>0){
                 this.mumList = response.data.data;
                 this.loading = false;
                 that.nodata=true;
               }else{
                 that.nodata=false;
                 this.loading = true;
               }

            }
          }else if(response.data.success==999){
            this.$router.push({ path: './login'});

          }else{
            console.log("接口异常");
          }
        }, response => {
        })
      }
    }
  }
</script>

<style scoped>
  .pw_bg{
    position: relative;
    width: 100%;
    height: 96vh;
    background-color: rgba(196, 77, 65, 0.85);
    background: url("../../static/images/pw_bg.png") center repeat-y;
    background-size: 100% 100%;
    overflow: hidden;
  }
  .pwHeard{
    width:100%;
    height: 1rem;
    position: relative;
  }
  .h_back{
    background: url("../../static/images/back_black.svg") center no-repeat;
    background-size: 100% 100%;
    width: .55rem;
    height: 1rem;
    float: left;
    display: block;
  }
  .swiper-container{
    height: 25.2rem;
    position: absolute;
    left:0;
    right: 0;
    top: 1rem;
    bottom: 0;
    margin: auto;
    margin-left: .75rem;
  }
  .swiper-slide{
    width: 15.75rem!important;
    height: 23.8rem;
    border-radius: 0.4rem;
    background-color: rgba(255, 255, 255, 1);
    padding: .7rem .75rem;
    margin-right: .5rem!important;
  }

  .h_title{
    height: 1rem;
    width: 10rem;
    line-height: 1rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.8rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    display: block;
    vertical-align: top;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }
.h_store{
  height: 1rem;
  line-height: 1rem;
  color: rgba(196, 77, 65, 1);
  font-size: 0.8rem;
  font-family: PingFang-SC-Regular;
  position: absolute;
  display: block;
  right: 0;
}
  .mineList,.mineLists{
    width: 100%;
    margin-top: 2rem;
    overflow: auto;
    height: 18.8rem;
  }
  .nodataContent{
    width: 100%;
    margin-top: 2rem;
    height: 18.8rem;
    text-align: center;
  }
  .nodataContent img{
    width: 4.35rem;
    height: 4.35rem;
    display: block;
    margin: 6rem auto 1rem;
  }
  .nodataTip{
    width: 100%;
    height: 0.7rem;
    line-height: 0.7rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: center;
    font-family: PingFang-SC-Bold;

  }
  .getMore{
    width: 15.5rem;
    height: 1.8rem;
    border-radius: 0.4rem;
    background-color: rgba(196, 77, 65, 1);
    line-height: 1.8rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.7rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    display: block;
    margin-top: 2rem;
  }
  .mineList li,.mineLists li{
    width: 14.5rem;
    height: 1rem;
    border-radius: 0.4rem;
    background-color: rgba(241, 241, 242, 1);
    position: relative;
    padding: .4rem .5rem;
    margin-bottom: .55rem;
  }
  .mineList li span,.mineLists li span{
    width: 13rem;
    height: 1rem;
    line-height: 1rem;
    display: block;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFangSC-Medium;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }
  .mineList li a,.mineLists li a{
    position: absolute;
    right: .5rem;
    top: .5rem;
    display: block;
    height: 1rem;
    line-height: 1rem;
    color: rgba(153, 153, 153, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFangSC-Regular;
  }
  .panation{
    width: 10rem;
    margin: .5rem auto 0;
    text-align: center;
    height: .25rem;
  }
  .navbar{
    width: 0.25rem;
    height: 0.25rem;
    border-radius: 0.15rem;
    background-color: rgba(216, 216, 216, 1);
    display: inline-block;
  }
  .navbar.cur{
    width: 1rem;
    height: 0.25rem;
    border-radius: 0.15rem;
    background-color: rgba(196, 77, 65, 1);

  }
</style>



// WEBPACK FOOTER //
// src/view/mine.vue